import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStartDate } from '../context/StartDateContext';

const StartDateSelector: React.FC = () => {
  const { t } = useTranslation();
  const { setStartDate } = useStartDate();
  const [selectedDate, setSelectedDate] = useState<string>('');
  
  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedDate(e.target.value);
  };
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (selectedDate) {
      // Create a new Date object from the selected date
      const date = new Date(selectedDate);
      setStartDate(date);
    }
  };
  
  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh] px-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-8 transform transition-all">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-[#a6ce86] mb-2">
            {t('startDateSelector.welcome', 'Welcome to Ramadan Planner')}
          </h1>
          <p className="text-gray-600">
            {t('startDateSelector.selectDate', 'Please select when Ramadan started this year')}
          </p>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="relative">
            <label 
              htmlFor="ramadan-start-date" 
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              {t('startDateSelector.ramadanStartDate', 'First day of Ramadan')}
            </label>
            <input
              type="date"
              id="ramadan-start-date"
              value={selectedDate}
              onChange={handleDateChange}
              className="block w-full px-4 py-3 text-gray-900 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-primary focus:border-transparent"
              required
            />
          </div>
          
          <button
            type="submit"
            className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#a6ce86] hover:bg-[#a6ce86] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#a6ce86]"
          >
            {t('startDateSelector.continue', 'Continue to My Planner')}
          </button>
        </form>
        
        <div className="mt-8 text-center text-sm text-gray-500">
          <p>
            {t('startDateSelector.note', 'You can change this date later from your profile settings')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default StartDateSelector; 